import { connect } from 'react-redux';
import { addonFormResetThunk } from 'state/addonForm/addonForm.thunks';
import type { ThunkDispatch } from 'state/state.common';

export interface OwnProps {
  tabId: string;
  className?: string;
}

export interface DispatchProps {
  onTradeDone(): void;
}

export type TradeDoneProps = OwnProps & DispatchProps;

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => ({
  onTradeDone() {
    dispatch(addonFormResetThunk(tabId));
  },
});

export const connectTradeDoneButton = connect(null, mapDispatchToProps);
